import { ReactPainter } from './ReactPainter';

export { ReactPainter } from './ReactPainter';
export { usePainter } from './usePainter';
export type { UsePainterProps, UsePainterResult } from './usePainter';

export default ReactPainter;
